<template>
  <v-img :eager="true" :src='fetchPictureFrom(video)' :alt="alt"/>
</template>

<script>
  export default {
    name: "ImageVideoCard",
    props: [
      'video',
      'alt'
    ],
    methods: {
      fetchPictureFrom(video) {
        // @todo: Remove if condition to avoid workarounds
        // This workaround was implemented after fixing the problem with the wrong column type
        // for "image_all" field. It was changed to JSON column type and the previous column
        // VARCHAR(255) was dropped to solve the problem. Since there are a lot of existent content
        // that do not have the values then we will use as default the column "image" that store
        // a single value of the image source, by doing so we can still show the image for
        // old video data that has "image_all" equal NULL.

        if (video.image_all === null) {
          return video.image;
        }

        let imageResolutionCollection = video.image_all;
        //for (let key in imageResolutionCollection) {
            return imageResolutionCollection['medium'].url;
        //}
      }
    }
  }
</script>
